import Config from '@config';
import {
  FiltersGrid,
  Pagination,
  ReferenceBook,
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@gasbi/shared/index';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const psgTariffProductTypesApi = createApi({
  reducerPath: 'psgTariffProductTypesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/psg-tariff-product-types`,
  }),
  tagTypes: ['PsgTariffProductType'],
  endpoints: builder => ({
    getPsgTariffProductTypes: builder.query<ReferenceBook[], void>({
      query: () => ({ url: '/' }),
      providesTags: () => ['PsgTariffProductType'],
    }),
    getPsgTariffProductTypeById: builder.query<ReferenceBook, string>({
      query: id => ({ url: `/${id}` }),
      providesTags: (_, __, id) => [{ type: 'PsgTariffProductType', id }],
    }),
    getPsgTariffProductTypesI: builder.infiniteQuery<
      ReferenceBook[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '/query',
        method: 'GET',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['PsgTariffProductType'],
    }),
  }),
});

export const {
  useGetPsgTariffProductTypesQuery,
  useGetPsgTariffProductTypeByIdQuery,
} = psgTariffProductTypesApi;

export const useGetPsgTariffProductTypesInfiniteQuery =
  normalizeInfiniteQueryData(
    psgTariffProductTypesApi.useGetPsgTariffProductTypesIInfiniteQuery,
  );
